import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('emailAddressStore')
@observer
class emailAddress extends Component {
  render() {
    const { emailAddressStore, location } = this.props
    const { isFetching } = emailAddressStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default emailAddress;
